import objectFitImages from 'object-fit-images';
import 'picturefill';
import 'lazysizes';
import 'nodelist-foreach-polyfill';
import './wine-carousel';
import './dialog';

const menuButton = document.querySelector('[aria-controls=siteMenu]');

function toggleMenu() {
  const expanded = menuButton.getAttribute('aria-expanded') !== 'true';
  menuButton.setAttribute('aria-expanded', expanded ? 'true' : 'false');
  document.body.classList[expanded ? 'add' : 'remove']('is-menu-open');
  menuButton.firstElementChild.classList[expanded ? 'add' : 'remove']('is-active');
  return expanded;
}

menuButton.addEventListener('click', toggleMenu);

document.addEventListener('keydown', e => {
  if (menuButton.getAttribute('aria-expanded') === 'true' && e.key === 'Escape') {
    if (toggleMenu()) {
      document.getElementById('siteMenu').focus();
    } else {
      menuButton.focus();
    }
  }
})

let ticking = false;
const headerHeightDifference = 172 - 107;

function update() {
  document.body.classList[pageYOffset > headerHeightDifference ? 'add' : 'remove']('is-scrolled-past-header');
  ticking = false;
}

window.addEventListener('scroll', () => {
  if (! ticking) {
    window.requestAnimationFrame(update);
    ticking = true;
  }
})



//* objectfit polyfill =================================================== */

objectFitImages();


//* scroll to anchor =================================================== */

// all hashtags
$(document).on('click','a[href^="#"]',function(){
  var $this = $(this);
  var aId = $this.attr('href').replace('#','');;
  var $anchorElement = $('[id="' + aId + '"], [name="' + aId + '"], [data-id="' + aId + '"]');
  if ($anchorElement.length > 0) {
    Scroll.toAnchor(aId);
    return false;
  }
});

// scroll if hashtag
$(document).ready(function(){
  var hash = window.location.hash.replace('#', '');
  if (hash != '') {
    Scroll.toAnchor(hash);
  }
});




//* mailing list form submit =================================================== */

var loadingElement = '<div class="loader">\
  <svg class="circular-loader" viewBox="25 25 50 50" >\
    <circle class="loader-path" cx="50" cy="50" r="20" fill="none" stroke="#ffffff" stroke-width="3" />\
  </svg>\
</div>';

$(document).on('submit','.MailingListForm2',function(e){

  e.preventDefault();

  // init
  var $thisForm = $(this);
  var thisUrl = $thisForm.attr('action');
  var thisFormId = $thisForm.attr('id');

  if ($thisForm.find('[name="Email"]').val().length) {

    // generate form data
    var form_data = new FormData(document.getElementById(thisFormId));
    form_data.append($(this).attr('name'), $(this).val());
    console.log(form_data);
    console.log($thisForm.serialize());

    // set form status to loading
    $thisForm.find('input, select, textarea').attr('disabled', 'disabled');
    $thisForm.prepend(loadingElement);
    $thisForm.addClass('--is-loading');
    $thisForm.find('.error').remove();

    $.ajax({
      url: thisUrl,
      type: 'post',
      data: form_data,
      contentType: false,
      cache: false,
      enctype: 'multipart/form-data',
      // cache: false,
      // contentType: 'application/x-www-form-urlencoded',
      crossDomain: true,
      processData: false,
      error: function(response, textStatus, errorThrown){

        console.log('error');

        console.log(response);
        console.log(textStatus);
        console.log(errorThrown);

        // remove loading status
        $thisForm.find('input, select, textarea').removeAttr('disabled');
        $thisForm.find('.loader').remove();
        $thisForm.removeClass('--is-loading');

        // include error
        $thisForm.append('<div class="error"><p><strong>Sorry, there was an error submitting your form. Please try again, or call if issues persist.</strong></p><p>Message: ' + errorThrown + '</p></div>');

      },
      success: function(response, textStatus, jqXHR) {

        console.log('success');

        console.log(response);
        console.log(textStatus);
        console.log(jqXHR);

        $thisForm.find('input, select, textarea').removeAttr('disabled');
        $thisForm.find('.loader').remove();
        $thisForm.removeClass('--is-loading');

        if (response.success && response.finished) {

          $thisForm.replaceWith('<div class="success">Thanks for subscribing to our mailing list.</div>');

        } else if (response.errors || response.formErrors) {

          // // loop through field specific errors
          // for (var key in response.errors) {
          //   if (!response.errors.hasOwnProperty(key)) continue;
          //   var messages = response.errors[key];
          //   var $errors  = $("<p>", {"class": "has-error"});
          //   for (var i = 0; i < messages.length; i++) {
          //     var $li = $("<span>");
          //     $li.html(messages[i]);
          //     $errors.append($li);
          //   }

          //   var $input = $("*[name=" + key + "], *[name='" + key + "[]']");

          //   var $formGroup = $input.parents(".form-group");
          //   $formGroup.addClass("has-error");

          //   $formGroup.append($errors);
          // }

          // // loop through form errors
          // var formErrors = '';
          // for (var key in response.formErrors) {
          //   if (!response.formErrors.hasOwnProperty(key)) continue;
          //   formErrors += '<p>' + response.formErrors[key] + '</p>';
          // }

          // // display errors
          // $('.form-freeform').append('<div class="error"><p><strong>Sorry, there was an error submitting your form.</strong></p>' + formErrors + '</div>');


        }

      }
    });

  }

  return false;
});


// connect with WD shop
$(function(){

  // check if logged in
  $.getJSON('https://shop.kellermeister.com.au/index.cfm?method=remote.loginWidget&relocateTo=&?callback=?', function(response) {
    // console.log(response);
    var isLoggedIn = false;
    if (response.indexOf('Hello') !== -1) {
      isLoggedIn = true;
      $('.SiteHeader-login, .SiteMenu-login').text('Account');
      $('.SiteHeader-login, .SiteMenu-login').attr('href', 'https://shop.kellermeister.com.au/account');
    }
  });

  // get cart status
  $.getJSON('https://shop.kellermeister.com.au/index.cfm?method=remote.modalCart&dontShowIfZero=0&remoteOrderID=&thirdPartyCookiesSupported=&?callback=?', function(response) {
    // console.log(response);
    const regex = /v65\-widgetModalCart\-itemCount\"\>([0-9]+)\<\//;
    const found = response.match(regex);
    var cartItems = found[1];
    if (cartItems && $('.SiteHeader-shoppingCart').length) {
      $('.SiteHeader-shoppingCart span').text(cartItems);
      $('.SiteHeader-shoppingCart').addClass('--has-items');
    }
  });

});
